<script lang="ts" setup>
import { ButtonStyle } from '~/static/enums/components/button'
import AButton from '~/components/atoms/buttons/Button.vue'
import RModal from '~/components/organs/Modal.vue'
import { closeModal } from '~/utils/Modal'

interface Props {
  title: string
  text: string
}

defineProps<Props>()
const cancel = () => {
  closeModal()
}
const toTariffs = () => {
  useRouter().push('/pricing')
  closeModal()
}

</script>

<template>
  <RModal
    ref="refModal"
    name-modal="nameChangeModal"
    @close="cancel"
  >
    <template #header>
      <h5
        class="modal-title fs-5"
        id="nameChangeModalLabel"
      >
        {{ title }} доступно на тарифе Pro
      </h5>
    </template>

    <template #body>
      <div class="body">
        <span class="d-block mb-lg-2">
          Подключите тариф Pro, чтобы систематизировать карточки
        </span>
      </div>
    </template>
    <template #footer>
      <AButton
        :button-style="ButtonStyle.Primary"
        @click="toTariffs"
      >
        Перейти на тариф Pro
      </AButton>
    </template>
  </RModal>
</template>

<style lang="scss" scoped>
.body {
  width: 100%;
}
</style>
